export default "__VITE_ASSET__B2hO5d7F__"